(function () {
  var DEBOUNCE_MS = 220;
  var SKIP_SELLING_PLAN_GROUP_ID = 'bc217b6c155c9d91f70a8858a88f3ea1355cd18f';

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function fetchSuggestions(url, q) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var u =
      url +
      sep +
      'q=' +
      encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10';
    return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('suggest failed');
      return r.json();
    });
  }

  function renderCents(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function formatShopifyMoney(priceVal) {
    if (priceVal == null || priceVal === '') return '—';
    if (typeof priceVal === 'number' && isFinite(priceVal)) {
      return renderCents(Math.round(priceVal));
    }
    var raw = String(priceVal).trim();
    var stripped = raw.replace(/[^\d.,]/g, '').replace(',', '.');
    if (!stripped) return '—';
    var cents;
    if (/\.\d/.test(stripped)) {
      cents = Math.round(parseFloat(stripped) * 100);
    } else {
      var n = parseInt(stripped, 10);
      if (!isFinite(n)) return '—';
      cents = n >= 100 ? n : Math.round(n * 100);
    }
    if (!isFinite(cents)) return '—';
    return renderCents(cents);
  }

  function cleanSuggestProductUrl(productUrl) {
    if (!productUrl) return '#';
    try {
      var u = new URL(productUrl, window.location.origin);
      var path = u.pathname;
      var v = u.searchParams.get('variant');
      return v ? path + '?variant=' + encodeURIComponent(v) : path;
    } catch (e) {
      return productUrl.split('?')[0] || '#';
    }
  }

  function productPageUrl(product, variant) {
    var path = '/products/' + product.handle;
    if (variant && variant.id) return path + '?variant=' + encodeURIComponent(String(variant.id));
    return path;
  }

  function normalizeImgUrl(u) {
    if (!u) return '';
    var s = String(u);
    if (s.indexOf('//') === 0) return 'https:' + s;
    return s;
  }

  function suggestImageUrl(p) {
    if (p.featured_image && p.featured_image.url) return normalizeImgUrl(p.featured_image.url);
    if (typeof p.image === 'string') return normalizeImgUrl(p.image);
    if (p.image && p.image.url) return normalizeImgUrl(p.image.url);
    return '';
  }

  function handleFromProductUrl(productUrl) {
    try {
      var path = new URL(productUrl, window.location.origin).pathname;
      var m = path.match(/\/products\/([^/?]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function pickVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function pickSubscribeAllocation(variant) {
    var all = variant.selling_plan_allocations || [];
    for (var i = 0; i < all.length; i++) {
      var gid = all[i].selling_plan_group_id;
      if (String(gid) !== SKIP_SELLING_PLAN_GROUP_ID) return all[i];
    }
    return null;
  }

  function productImageUrl(product) {
    var fi = product.featured_image;
    if (typeof fi === 'string') return normalizeImgUrl(fi);
    if (fi && fi.src) return normalizeImgUrl(fi.src);
    if (product.media && product.media[0] && product.media[0].src) {
      return normalizeImgUrl(product.media[0].src);
    }
    return '';
  }

  function refreshRobustCart() {
    if (window.robustCart && typeof window.robustCart.refreshCart === 'function') {
      return window.robustCart.refreshCart();
    }
    return Promise.resolve();
  }

  function openRobustCart() {
    if (window.robustCart && typeof window.robustCart.openCart === 'function') {
      window.robustCart.openCart();
    }
  }

  function addToCart(variantId, sellingPlanId) {
    var item = { id: variantId, quantity: 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      })
      .then(function () {
        return refreshRobustCart();
      })
      .then(function () {
        openRobustCart();
        removeBackdrop();
        document.querySelectorAll('[data-collection-hfb059-results]').forEach(function (res) {
          res.innerHTML = '';
          res.setAttribute('hidden', '');
        });
      });
  }

  function buildSuggestOnlyCard(p0) {
    var url = cleanSuggestProductUrl(p0.url);
    var imgSrc = suggestImageUrl(p0);
    var wrap = document.createElement('div');
    wrap.className = 'collection-hfb059-search__card';
    var priceStr = p0.price ? formatShopifyMoney(p0.price) : '';

    var media = document.createElement('a');
    media.className = 'collection-hfb059-search__card-media';
    media.href = url;
    var img = document.createElement('img');
    img.src = imgSrc || '';
    img.alt = '';
    img.loading = 'lazy';
    media.appendChild(img);

    var body = document.createElement('div');
    body.className = 'collection-hfb059-search__card-body';

    var title = document.createElement('a');
    title.className = 'collection-hfb059-search__card-title';
    title.href = url;
    title.textContent = p0.title || '';

    var actions = document.createElement('div');
    actions.className = 'collection-hfb059-search__card-actions';

    var btnPdp = document.createElement('a');
    btnPdp.className = 'collection-hfb059-search__btn collection-hfb059-search__btn--atc';
    btnPdp.href = url;
    btnPdp.innerHTML =
      '<span class="collection-hfb059-search__btn-label">View product</span>' +
      (priceStr ? '<span class="collection-hfb059-search__btn-price">' + priceStr + '</span>' : '');

    actions.appendChild(btnPdp);
    body.appendChild(title);
    body.appendChild(actions);
    wrap.appendChild(media);
    wrap.appendChild(body);
    return wrap;
  }

  function buildProductCard(p0, product) {
    var variant = pickVariant(product);
    var url = productPageUrl(product, variant);
    var imgSrc = productImageUrl(product) || suggestImageUrl(p0);
    var wrap = document.createElement('div');
    wrap.className = 'collection-hfb059-search__card';

    var media = document.createElement('a');
    media.className = 'collection-hfb059-search__card-media';
    media.href = url;
    var img = document.createElement('img');
    img.src = imgSrc || '';
    img.alt = '';
    img.loading = 'lazy';
    media.appendChild(img);

    var body = document.createElement('div');
    body.className = 'collection-hfb059-search__card-body';

    var title = document.createElement('a');
    title.className = 'collection-hfb059-search__card-title';
    title.href = url;
    title.textContent = product.title || p0.title || '';

    var actions = document.createElement('div');
    actions.className = 'collection-hfb059-search__card-actions';

    var atcPrice = variant ? formatShopifyMoney(variant.price) : '';
    var subAlloc = variant ? pickSubscribeAllocation(variant) : null;
    var subPrice = subAlloc
      ? formatShopifyMoney(subAlloc.per_delivery_price || subAlloc.price || '')
      : '';
    var variantId = variant ? variant.id : null;
    var subPlanId = subAlloc ? subAlloc.selling_plan_id : null;

    var btnAtc = document.createElement('button');
    btnAtc.type = 'button';
    btnAtc.className = 'collection-hfb059-search__btn collection-hfb059-search__btn--atc';
    btnAtc.innerHTML =
      '<span class="collection-hfb059-search__btn-label">Add to cart</span>' +
      '<span class="collection-hfb059-search__btn-price">' +
      (atcPrice || '—') +
      '</span>';
    if (!variantId || !variant.available) {
      btnAtc.disabled = true;
      btnAtc.classList.add('collection-hfb059-search__btn--disabled');
    } else {
      btnAtc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btnAtc.disabled = true;
        addToCart(variantId, null)
          .catch(function () {
            window.location.href = url;
          })
          .finally(function () {
            btnAtc.disabled = false;
          });
      });
    }

    actions.appendChild(btnAtc);

    if (subAlloc && subPlanId && variantId && variant.available) {
      var btnSub = document.createElement('button');
      btnSub.type = 'button';
      btnSub.className = 'collection-hfb059-search__btn collection-hfb059-search__btn--sub';
      btnSub.innerHTML =
        '<span class="collection-hfb059-search__btn-label">Subscribe</span>' +
        '<span class="collection-hfb059-search__btn-price">' +
        (subPrice || '—') +
        '</span>';
      btnSub.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btnSub.disabled = true;
        addToCart(variantId, subPlanId)
          .catch(function () {
            window.location.href = url;
          })
          .finally(function () {
            btnSub.disabled = false;
          });
      });
      actions.appendChild(btnSub);
    }

    body.appendChild(title);
    body.appendChild(actions);
    wrap.appendChild(media);
    wrap.appendChild(body);
    return wrap;
  }

  function removeBackdrop() {
    document.querySelectorAll('[data-collection-hfb059-backdrop]').forEach(function (b) {
      b.remove();
    });
    document.body.classList.remove('collection-hfb059-search-overlay-open');
  }

  function anyResultsPanelOpen() {
    var open = false;
    document.querySelectorAll('[data-collection-hfb059-results]').forEach(function (res) {
      if (!res.hasAttribute('hidden')) open = true;
    });
    return open;
  }

  function isMobileSearchViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function syncBackdrop() {
    if (!anyResultsPanelOpen()) {
      removeBackdrop();
      return;
    }
    if (isMobileSearchViewport()) {
      removeBackdrop();
      return;
    }
    if (document.querySelector('[data-collection-hfb059-backdrop]')) return;
    var el = document.createElement('div');
    el.className = 'collection-hfb059-search__backdrop';
    el.setAttribute('data-collection-hfb059-backdrop', '');
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
    document.body.classList.add('collection-hfb059-search-overlay-open');
    el.addEventListener('click', function () {
      document.querySelectorAll('[data-collection-hfb059-search]').forEach(function (mod) {
        var res = mod.querySelector('[data-collection-hfb059-results]');
        if (res) {
          res.innerHTML = '';
          res.setAttribute('hidden', '');
        }
      });
      removeBackdrop();
    });
  }

  function renderResults(container, products) {
    container.removeAttribute('hidden');
    if (!products || !products.length) {
      container.innerHTML =
        '<p class="collection-hfb059-search__empty">No products found. Try another search.</p>';
      syncBackdrop();
      return;
    }

    var p0 = products[0];
    var handle = handleFromProductUrl(p0.url || '');
    container.dataset.hfb059Req = String((parseInt(container.dataset.hfb059Req, 10) || 0) + 1);
    var reqToken = container.dataset.hfb059Req;

    container.innerHTML =
      '<p class="collection-hfb059-search__loading">Loading product…</p>';
    syncBackdrop();

    if (!handle) {
      if (container.dataset.hfb059Req !== reqToken) return;
      container.innerHTML = '';
      container.appendChild(buildSuggestOnlyCard(p0));
      syncBackdrop();
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product js');
        return r.json();
      })
      .then(function (product) {
        if (container.dataset.hfb059Req !== reqToken) return;
        container.innerHTML = '';
        container.appendChild(buildProductCard(p0, product));
        syncBackdrop();
      })
      .catch(function () {
        if (container.dataset.hfb059Req !== reqToken) return;
        container.innerHTML = '';
        container.appendChild(buildSuggestOnlyCard(p0));
        syncBackdrop();
      });
  }

  function initModule(root) {
    var form = root.querySelector('[data-collection-hfb059-form]');
    var input = root.querySelector('[data-collection-hfb059-input]');
    var results = root.querySelector('[data-collection-hfb059-results]');
    if (!form || !input || !results) return;

    var suggestUrl = input.getAttribute('data-suggest-url');
    if (!suggestUrl) return;

    var runSuggestImmediate = function () {
      var q = (input.value || '').trim();
      if (q.length < 2) {
        results.innerHTML = '';
        results.setAttribute('hidden', '');
        syncBackdrop();
        return;
      }
      fetchSuggestions(suggestUrl, q)
        .then(function (data) {
          var products =
            data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products
              ? data.resources.results.products
              : [];
          renderResults(results, products);
        })
        .catch(function () {
          results.removeAttribute('hidden');
          results.innerHTML =
            '<p class="collection-hfb059-search__empty">Search is temporarily unavailable.</p>';
          syncBackdrop();
        });
    };

    var runSuggest = debounce(runSuggestImmediate, DEBOUNCE_MS);

    // Mobile: don't search as-you-type (re-rendering steals input focus and
    // closes the soft keyboard). Search runs on submit (Enter) instead.
    input.addEventListener('input', function () {
      if (isMobileSearchViewport()) return;
      runSuggest();
    });
    input.addEventListener('focus', function () {
      if (isMobileSearchViewport()) return;
      if (!results.hasAttribute('hidden')) return;
      if ((input.value || '').trim().length >= 2) runSuggestImmediate();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = (input.value || '').trim();
      if (q.length < 2) return;
      // Enter always shows results in-panel; never redirect.
      runSuggestImmediate();
      // Drop the keyboard on mobile so the results panel is visible.
      if (isMobileSearchViewport()) input.blur();
    });

    function closeResultsIfOutside(e) {
      if (root.contains(e.target)) return;
      if (results.hasAttribute('hidden')) return;
      results.innerHTML = '';
      results.setAttribute('hidden', '');
      syncBackdrop();
    }

    document.addEventListener('mousedown', closeResultsIfOutside);
    document.addEventListener('touchstart', closeResultsIfOutside, { passive: true });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (results.hasAttribute('hidden')) return;
        results.innerHTML = '';
        results.setAttribute('hidden', '');
        syncBackdrop();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-collection-hfb059-search]').forEach(initModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
